import { create } from 'zustand';
import axios from 'axios';

export interface PaymentReportItem {
  CollectionDate: string;
  CurrentCode: string;
  CurrentAccountName: string;
  Amount: number;
  Installment: number;
}

export interface PaymentLogItem {
  id: string;
  paymentId: string;
  customerId: string;
  currentCode: string;
  currentName: string;
  amount: number;
  instalment: number;
  createUser: string;
  createDate: string;
  isRecordErp: boolean;
  bankRecord: string;
  bankMessage: string;
  status: number;
}

interface ReportState {
  reportData: PaymentReportItem[];
  logData: PaymentLogItem[];
  isLoading: boolean;
  error: string | null;
  fetchPaymentReport: (startDate: string, endDate: string,currentCode:string) => Promise<void>;
  fetchLogs: (customerId: string) => Promise<void>; // ✅ customerId parametreli
}

const useReportStore = create<ReportState>((set) => ({
  reportData: [],
  logData: [],
  isLoading: false,
  error: null,

  fetchPaymentReport: async (startDate, endDate,currentCode) => {
    try {
      set({ isLoading: true, error: null });

      const url = 'https://bastas.duyu.alter.net.tr/PaymentReport';
      const formData = new FormData();
      formData.append('Token', 'RasyoIoToken2021');
      formData.append('StartDate', startDate);
      formData.append('EndDate', endDate);
      formData.append('CurrentCode', currentCode); // ✅ dinamik müşteri ID

      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (
        Array.isArray(response.data) &&
        response.data.length === 1 &&
        response.data[0].code === 'EmptyDataTable'
      ) {
        set({ reportData: [], isLoading: false });
      } else {
        set({ reportData: response.data, isLoading: false });
      }
    } catch (err: any) {
      set({
        error: err.message || 'Rapor alınırken hata oluştu',
        isLoading: false,
      });
    }
  },

  fetchLogs: async (customerId: string) => {
    try {
      set({ isLoading: true, error: null });

      const url = 'https://pay.duyu.alter.net.tr/api/Log';

      const formData = new FormData();
      formData.append('Token', 'RasyoIoToken2021');
      formData.append('DealerId', customerId); // ✅ dinamik müşteri ID

      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data?.result) {
        set({ logData: response.data.result, isLoading: false });
      } else {
        set({ logData: [], isLoading: false });
      }
    } catch (err: any) {
      set({
        error: err.message || 'Log verileri alınırken hata oluştu',
        isLoading: false,
      });
    }
  }
}));

export default useReportStore;
